import React from "react";

const Map = () => {
  return (
    <>
      <div className="map-area">
        <div
          id="map"
          style={{
            display: "flex",
            justifyItems: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h1 className="text-white text-center">Map</h1>
          <br />
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3618.7685579310314!2d67.13569591080491!3d24.905874977807493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33906ead1899d%3A0x3c0681e6f7d5dc14!2sHabib%20University!5e0!3m2!1sen!2s!4v1697038402204!5m2!1sen!2s"
            width={"80%"}
            height={"450"}
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <section className="brand-area top-padding">
        <div className="container">
          <div className="row wrapper-brand justify-content-center">
            <div className="col-xl-5 col-lg-6 col-md-6">
              <div className="section-tittle text-center mb-30">
                <h2>Sponsors</h2>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="brand-active pt-50 pb-40 slick-initialized slick-slider">
                <div className="slick-list draggable">
                  <div
                    className="slick-track"
                    style={{
                      opacity: 1,
                      width: "4080px",
                      transform: "translate3d(-1680px, 0px, 0px)",
                    }}
                  >
                    <div
                      className="single-brand slick-slide slick-cloned"
                      data-slick-index="-5"
                      aria-hidden="true"
                      tabIndex="-1"
                      style={{ width: "240px" }}
                    >
                      <img
                        src="./img/gallery/xbrand2.png.pagespeed.ic.mUTkfdkIZX.webp"
                        alt=""
                      />
                    </div>
                    <div
                      className="single-brand slick-slide slick-cloned"
                      data-slick-index="-5"
                      aria-hidden="true"
                      tabIndex="-1"
                      style={{ width: "240px" }}
                    >
                      <img
                        src="./img/gallery/xbrand2.png.pagespeed.ic.mUTkfdkIZX.webp"
                        alt=""
                      />
                    </div>
                    <div
                      className="single-brand slick-slide slick-cloned"
                      data-slick-index="-5"
                      aria-hidden="true"
                      tabIndex="-1"
                      style={{ width: "240px" }}
                    >
                      <img
                        src="./img/gallery/xbrand2.png.pagespeed.ic.mUTkfdkIZX.webp"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Map;
